export class TkaTypography {
	constructor(protected readonly css: string) {}

	public getCSS(): string {
		return this.css;
	}
}
